<!--
 * @Description: 消息中心页面
 * @Author: shh,gaohc
 * @Date: 2022-08-26 16:43:52
-->
<template>
  <div class="body">
    <el-row style="margin: 25px 40px;" :gutter="0" type="flex" justify="space-between" >
      <el-col :span="8" style="text-align: left;">
        <span class="search-title">日期：</span>
        <el-date-picker v-model="selectedDate" align="right" type="date" clearable
          :default-value="selectedDate" placeholder="选择日期" 
          size="small" :picker-options="pickerOptions" style="width: 240px;" />
      </el-col>
      <el-col :span="8" style="text-align: left;">
        <span class="search-title">类型：</span>
        <el-select size="small" filterable  v-model="filterParams.type" clearable  placeholder="请选择" style="width: 240px;" >
          <el-option v-for="(item,key) in noticeTypeMap" :key="key" :label="item" :value="key">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" style="text-align: right;">
        <el-button size="small" @click="handleQuery"  type="primary" icon="el-icon-search">搜 索</el-button>
      </el-col>      
    </el-row>
    <div class="main-line"></div>
    <div v-if="noticeList.length > 0 || filterParams.readStatus !== 'undefined' || filterParams.readStatus !== ''">
      <el-row style="margin: 25px 40px;" >
        <el-col :span="24" style="text-align: left;">
          <el-checkbox v-model="filterParams.readStatus" :false-label="2" :true-label="0" @change="changeReadStatusToNoRead">
            仅显示未读消息
          </el-checkbox>
          <span class="read-style" @click="handleAllSignToRead">全部标记为已读</span>
        </el-col>
      </el-row>
      <div style="padding: 20px 40px; border-top: 1px solid #EAEEF5;" v-for="(item,index) in noticeList" :key="index">
        <div @click.stop="updateAssignNoticeToRead(item.id, item.readStatus)" :style="{'cursor': item.readStatus == 0 ? 'pointer' : ''}">
          <el-row  :gutter="0" type="flex" justify="space-between" align="middle" >
            <el-col :span="20" style="text-align: left;">
              <div class="notice-item-title" v-if="item.title" >
                <el-badge v-show="item.readStatus == 0" :is-dot="changeReadStatus(item.readStatus)" class="item"></el-badge>
                <span style="margin-left: -6px;">{{splitStartStr(item.title)}}</span>
                <span style="color: #B59E45;">{{(splitCenterStr(item.title)).linkText}}</span>
                <span>{{splitEndStr(item.title)}}</span>
              </div>
              <div class="notice-item-dec" v-if="item.content">
                <span>{{item.content == '' ? '' : splitStartStr(item.content)}}</span>
                <span style="color: #3E7EF5; cursor: pointer;" @click.stop="handleItem(item)">
                  {{(splitCenterStr(item.content)).linkText}}
                </span>
                <span v-if="splitEndStr(item.content).length">{{splitEndStr(item.content)}}</span>
              </div>
            </el-col >
            <el-col :span="4" style="text-align: right;">
              <span class="notice-item-time">{{item.noticeTimeStr}}</span>
            </el-col>
          </el-row>
        </div>
      </div>
      <el-row class="foot-pagination">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage" 
          :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize" 
          layout="total,prev, pager, next,sizes,jumper" :total="totalNumber" />
      </el-row>
    </div>
    <div v-else>
      <el-empty style="margin-top: 80px;" :image-size="200"></el-empty>
    </div>
    
    <!-- 入驻机构审核详情 -->
    <inst-review-details :visible="showReviewDetailsDialog" :mode="dialogMode" :instReviewId="instReviewId"
      :isGlobalAdmin="isInstGlobalAdmin" @handle-review-inst="handleInstReview"  @close-dialog="closeDetailsDialog" />
    
    <!-- 人员审核详情 -->
		<attendant-review-details :visible="showReviewDialog" :operate="operateAttendantReview"
			:attendantId="attendantId" :isGlobalAdmin="isAttentGlobalAdmin" @handle-review-attendant="handleAttendantReview"
      @handle-review-cert="handleAttendantCertReview"
			@close-dialog="closeSaveOrUpdateAttendantReviewDialog" :reviewType="attendantReviewType" />
    
    <!-- 审核意见弹框 -->
		<review-comments-dialog :showReviewCommentsDialog="showReviewCommentsDialog"
			@handle-close-review-comments-dialog="handleCloseReviewCommentsDialog"
			:reviewStatus = "reviewStatus" :reviewType="reviewType"
			@handle-review-comments-msg="handleReviewCommentsMsg" />

		<!-- 商户审核详详情 -->
		<mch-review-details-drawer :visible="showMchReviewDetailsDrawer" :isGlobalAdmin="isMchReviewGlobalAdmin"
			@handle-review-attendant="handleMchReview" @close-dialog="showMchReviewDetailsDrawer = false"
			:mchId="mchReviewId">
		</mch-review-details-drawer>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import headBus from '../pageframe/components/HeadBus.js'
import InstReviewDetails from '../review/components/InstReviewDetails.vue'
import AttendantReviewForm from '../review/components/AtdnOrCertReviewDetails.vue'
import ReviewCommentsDialog from '../review/components/ReviewCommentsDialog.vue'
import MchReviewDetails from '../review/components/mchReviewList/MchReviewDetails.vue'

export default {
  name: 'NoticeCenter',
  components: {
    'inst-review-details': InstReviewDetails,
		'attendant-review-details': AttendantReviewForm,
    'review-comments-dialog': ReviewCommentsDialog,
    'mch-review-details-drawer': MchReviewDetails,
  },

  data() {
    return {
      // 过滤查询相关变量 
      selectedDate: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: this.dateUtil.datePickerOptions.shortcuts
      },

      filterParams: {
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      totalNumber: 0,

      noticeTypeMap: {},
      noticeList: [],

      //以下是机构入驻审核（详情）（去审核）对话框使用
      showReviewDetailsDialog: false,
      dialogMode: '',
      instReviewId: '',
      isInstGlobalAdmin: null, //机构审核详情是否有审核权限标识

      //以下是人员/证书入驻审核（详情）（去审核）对话框使用
      showReviewDialog: false,
      operateAttendantReview: '',
      attendantReviewType: '',
			attendantId: '',
			isAttentGlobalAdmin: null, //详情是否有审核权限标识
			showReviewCommentsDialog: false,
			params: {
				id: '',
				status: '',
			},
      reviewStatus: '',
      reviewType: '',

      //以下是商户入驻审核（详情） （去审核）抽屉使用
      showMchReviewDetailsDrawer: false,
      isMchReviewGlobalAdmin: null, //商户审核详情是否有审核权限标识
      mchReviewId: '',//商户审核id
    }
  },
  
  methods:{
    async initData() {
      await this.getFilterDo();
      await this.listNotice();
    },

    //获取过滤条件
    getFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_NOTICE_FILTER_DO).then(result => {
          if (result != null) {
            this.noticeTypeMap = result.data.noticeTypeMap;
            resolve();
          }
        })
      })
    },

    //获取消息中心列表数据
    listNotice() {
      return new Promise((resolve) => {
        let header = this.encryptionUtil.signatureParams(this.filterParams,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_PAGE_NOTICES_V22,
          param: this.filterParams,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.noticeList = result.data || [];
            this.totalNumber = result.totalNumber;
            resolve();
          }
        })
      })
    },

    //更新指定消息为已读
    updateAssignNoticeToRead(id, readStatus) {
      if (readStatus == 1) {
        return;
      }
      let url = this.commonUtil.fillUrlArgments(Constant.URL_UPDATE_NOTICE_STATUS,id);
      this.queryNoticeStatusOrReviewStatus(url, {});
    },

    //更新指定消息状态或者人员，机构，商户审核(通过，驳回状态)
    queryNoticeStatusOrReviewStatus(url, param) {
      let header = this.encryptionUtil.signatureBody(param,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'PUT',
        url: url,
        param: param,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.listNotice();
      })
    },

    //全部标记为已读
    handleAllSignToRead() {
      if (this.noticeList.length == 0) return;
			this.appAxios('GET', Constant.URL_UPDATA_ALL_NOTICE_23_READ).then(result => {
				if (result == null) {
				  return;
				}
        this.listNotice();
        headBus.$emit('refreshHeaderHaveUnReadMessage',false);
			})	 
    },

    //搜索
    handleQuery() {
      if (this.selectedDate !== '' && this.selectedDate !== null) {
        this.filterParams.noticeDate = this.dateUtil.dateFormat(this.selectedDate);
      } else {
        this.filterParams.noticeDate = "";
      }
      this.filterParams.page = 1;
      this.listNotice();
    },

    //处理后端返回的字段，用于显示el-badge 需要Boolean值
    changeReadStatus(item) {
      return item == 0 ? true : false;
    },

    //仅显示未读消息item：0 显示未读 2已读未读都显示
    changeReadStatusToNoRead(item) {
      this.filterParams.readStatus = item == 0 ? item : '';
      this.listNotice();
    },

    //点击去审核，详情，人员列表去到对应的页面
    handleItem(item) {
      this.updateAssignNoticeToRead(item.id,item.readStatus);
      let obj = this.splitCenterStr(item.content);
      if (obj.type == 1 || obj.type == 3) {
        this.showReviewDetailsDialog = true;
        this.isInstGlobalAdmin =  obj.type == 3 ? false : true;
        this.dialogMode = 'details';
        this.instReviewId = obj.targetId;
      } else if (obj.type == 2 || obj.type == 7 || (obj.type == 4 && obj.linkText == "查看详情")) {
				this.attendantId = obj.targetId;
        this.attendantReviewType = obj.type;
        this.isAttentGlobalAdmin =  obj.type == 4 ? false : true;
				this.operateAttendantReview = 'details';
				this.showReviewDialog = true;
      } else if (obj.linkText == "人员列表") {
        this.$router.push({name: 'atdnlist'});
      } else if (obj.type == 5 || obj.type == 6) {
        this.mchReviewId = obj.targetId;
        this.isMchReviewGlobalAdmin =  obj.type == 6 ? false : true;
				this.showMchReviewDetailsDrawer = true;
      }
    },
    
    //机构审核详情里面审核通过或者驳回操作按钮
    handleInstReview(reviewStatus,version) {
      this.params.id = this.instReviewId;
      this.params.version = version;
      this.reviewStatus = reviewStatus;
      this.reviewType = 'inst';
      this.showReviewCommentsDialog = true;
    },

    //关闭机构审核详情对话框
    closeDetailsDialog(refresh) {
      this.showReviewDetailsDialog = false;
      if (refresh) {
        this.listNotice();
      }
    },

		//人员审核详情里面审核通过或者驳回操作触发
		handleAttendantReview(reviewStatus,version) {
			this.params.id = this.attendantId;
			this.params.version = version;
			this.reviewStatus = reviewStatus;
      this.reviewType = 'attendant';
			this.showReviewCommentsDialog = true;
		},

    //人员证书审核通过或者驳回操作触发
    handleAttendantCertReview(certParam) {
      this.params = certParam;
      this.reviewStatus = certParam.status;
      this.reviewType = 'cert';
      this.showReviewCommentsDialog = true;
    },

    //关闭护工审核详情对话框
		closeSaveOrUpdateAttendantReviewDialog(refresh) {
			this.showReviewDialog = false;
			if (refresh) {
        this.listNotice();
      }
		},

		//关闭审核意见弹框
		handleCloseReviewCommentsDialog(item) {
			this.showReviewCommentsDialog = item;
		},

		//审核意见框确定
		handleReviewCommentsMsg(comment,status) {
			this.params.comment = comment;
			this.params.status = status;
			this.queryReviewStatusChange();
			this.showReviewCommentsDialog = false;
      if (this.reviewType == 'inst') {
			  this.showReviewDetailsDialog = false;
      } else if (this.reviewType == 'attendant' || this.reviewType == 'cert') {
        this.showReviewDialog = false;
      } else if (this.reviewType == 'mchReview') {
        this.showMchReviewDetailsDrawer = false;
      }
		},

    //商户审核里面审核通过或者驳回操作按钮
		handleMchReview(reviewStatus, version) {
			this.params.id = this.mchReviewId;
			this.params.version = version;
			this.reviewStatus = reviewStatus;
      this.reviewType = 'mchReview'
			this.showReviewCommentsDialog = true;
		},

		queryReviewStatusChange() {
      let url = '';
      if (this.reviewType == 'inst') {
        url = Constant.URL_UPDATE_INSTITUTION_REVIEW_STATUS;
      } else if (this.reviewType == 'attendant') {
        url = Constant.URL_UPDATE_ATTENTDANT_REVIEW_STATUS;
      } else if (this.reviewType == 'cert') {
        url = Constant.URL_UPDATE_CERTIFICATE_REVIEW_STATUS;
      } else if (this.reviewType == 'mchReview') {
        url = Constant.URL_UPDATE_MERCHANT_REVIEW_RESULT;
      }
      this.queryNoticeStatusOrReviewStatus(url, this.params);
		},

    //截取两个字符串之间的内容 
    splitCenterStr(item) {
      let centerStr = '{' + item.match(/{(\S*)}/)[1] + '}';
      return JSON.parse(centerStr);
    },

    //截取某个字符串前面的内容
    splitStartStr(item) {
      return item.split('{')[0];
    },

    //截取某个字符串后面的内容 
    splitEndStr(item) {
      return item.split('}')[1];
    },

    //以下是分页控件操作
    handleSizeChange(val){
      this.filterParams.pageSize = val;
      this.listNotice();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.listNotice();
    },

  },

  mounted() {
    this.$emit("breadcrumb", {text1: '消息中心'});
    this.initData();
  }
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.search-title {
  color: #657180;
  font-size: 14px;
  display: inline-block;
  text-align: right;
}

.main-line {
  height: 10px;
  background-color: #f0f0f0;
}

.read-style {
  font-size: 14px;
  color: #3E7EF5;
  line-height: 20px;
  margin-left: 43px;
  cursor: pointer
}

.notice-item-title {  
  line-height: 20px;
  color: #000000;
  font-size: 14px;
}

.notice-item-dec {
  margin-top: 15px;
  line-height: 20px;
  color: #A5A5A5;
  font-size: 14px;
}

.notice-item-time {
  line-height: 20px;
  color: #A5A5A5;
  font-size: 14px;
}

.foot-pagination {
  text-align: right;
  right: 40px;
  border: solid 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/personal/NoticeCenter.vue